import jwtDecode from "jwt-decode";
import { DecodenToken } from "./Auth";

const isAuthenticated = (): boolean => {
	const token = localStorage.getItem("token");
	try {
		if (token !== null) {
			const decodedToken = jwtDecode(token) as DecodenToken;
		}
	} catch (error) {
		return false;
	}
	return !!token; // Return true if a token exists, otherwise false
};
export default isAuthenticated;
